import { EXPENSE_DETAILS_CONST } from '../actionConstants';

const INITIAL_STATE = {
    expenseData: {},
    expenseItems: [],
    expenseHistory: [],
    expenseError: false
}

export default (state = INITIAL_STATE, action) => {
    if (!action) {
        return state;
    }

    const { type, payload = {} } = action;

    switch (type) {
        case EXPENSE_DETAILS_CONST.EXPNS_DETAIL: {
            const { expenseData, expenseItems, error=false } = payload;
            return {
                ...state,
                expenseData,
                expenseItems,
                expenseError: error,
            }
        }
        case EXPENSE_DETAILS_CONST.EXPNS_HISTORY: {
            const {expenseHistory} = payload;
            return {
                ...state,
                expenseHistory,
            }
        }
        case EXPENSE_DETAILS_CONST.CLEAR_EXPNS: {
            return INITIAL_STATE
        }
        default:
            return state;
    }
}